import React from 'react';
import "style/style"
import {queryClient} from "../../../services/HttpService";
import {QueryClientProvider} from "react-query";
import {DashboardReportViewPaged} from "./DashboardReportViewPaged";

export const ReportGenerationPage = () => (
     <QueryClientProvider client={queryClient} contextSharing={true}>
        <DashboardReportViewPaged />
    </QueryClientProvider>
)